import { Component } from '@angular/core'

@Component({
    selector: 'ppw-not-authorized',
    templateUrl: './not-authorized.component.html',
    styleUrls: ['./not-authorized.component.scss']
})
export class NotAuthorizedComponent {}
